/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MaintenanceTicketSummaryDto
 */
export interface MaintenanceTicketSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof MaintenanceTicketSummaryDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceTicketSummaryDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceTicketSummaryDto
     */
    type: MaintenanceTicketSummaryDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceTicketSummaryDto
     */
    status: MaintenanceTicketSummaryDtoStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceTicketSummaryDto
     */
    needsFollowUp: boolean;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceTicketSummaryDto
     */
    priority: MaintenanceTicketSummaryDtoPriorityEnum;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceTicketSummaryDto
     */
    title: string;
    /**
     * 
     * @type {object}
     * @memberof MaintenanceTicketSummaryDto
     */
    assetId?: object | null;
    /**
     * 
     * @type {object}
     * @memberof MaintenanceTicketSummaryDto
     */
    siteId?: object | null;
    /**
     * 
     * @type {Date}
     * @memberof MaintenanceTicketSummaryDto
     */
    dueAt?: Date | null;
}


/**
 * @export
 */
export const MaintenanceTicketSummaryDtoTypeEnum = {
    Preventive: 'PREVENTIVE',
    Curative: 'CURATIVE'
} as const;
export type MaintenanceTicketSummaryDtoTypeEnum = typeof MaintenanceTicketSummaryDtoTypeEnum[keyof typeof MaintenanceTicketSummaryDtoTypeEnum];

/**
 * @export
 */
export const MaintenanceTicketSummaryDtoStatusEnum = {
    Open: 'OPEN',
    InProgress: 'IN_PROGRESS',
    Closed: 'CLOSED',
    Cancelled: 'CANCELLED'
} as const;
export type MaintenanceTicketSummaryDtoStatusEnum = typeof MaintenanceTicketSummaryDtoStatusEnum[keyof typeof MaintenanceTicketSummaryDtoStatusEnum];

/**
 * @export
 */
export const MaintenanceTicketSummaryDtoPriorityEnum = {
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH'
} as const;
export type MaintenanceTicketSummaryDtoPriorityEnum = typeof MaintenanceTicketSummaryDtoPriorityEnum[keyof typeof MaintenanceTicketSummaryDtoPriorityEnum];


/**
 * Check if a given object implements the MaintenanceTicketSummaryDto interface.
 */
export function instanceOfMaintenanceTicketSummaryDto(value: object): value is MaintenanceTicketSummaryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('needsFollowUp' in value) || value['needsFollowUp'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function MaintenanceTicketSummaryDtoFromJSON(json: any): MaintenanceTicketSummaryDto {
    return MaintenanceTicketSummaryDtoFromJSONTyped(json, false);
}

export function MaintenanceTicketSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaintenanceTicketSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'type': json['type'],
        'status': json['status'],
        'needsFollowUp': json['needsFollowUp'],
        'priority': json['priority'],
        'title': json['title'],
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'siteId': json['siteId'] == null ? undefined : json['siteId'],
        'dueAt': json['dueAt'] == null ? undefined : (new Date(json['dueAt'])),
    };
}

export function MaintenanceTicketSummaryDtoToJSON(json: any): MaintenanceTicketSummaryDto {
    return MaintenanceTicketSummaryDtoToJSONTyped(json, false);
}

export function MaintenanceTicketSummaryDtoToJSONTyped(value?: MaintenanceTicketSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'type': value['type'],
        'status': value['status'],
        'needsFollowUp': value['needsFollowUp'],
        'priority': value['priority'],
        'title': value['title'],
        'assetId': value['assetId'],
        'siteId': value['siteId'],
        'dueAt': value['dueAt'] == null ? value['dueAt'] : value['dueAt'].toISOString(),
    };
}

